define("settings/controllers/subscription/billing/payment-method", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _controller, _debug, _object, _service, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let BillingPaymentMethodController = _exports.default = (_class = class BillingPaymentMethodController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "settings", _descriptor4, this);
      _initializerDefineProperty(this, "stripe", _descriptor5, this);
      _initializerDefineProperty(this, "router", _descriptor6, this);
      _initializerDefineProperty(this, "payment", _descriptor7, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor8, this);
      _initializerDefineProperty(this, "events", _descriptor9, this);
      _initializerDefineProperty(this, "segment", _descriptor10, this);
      _initializerDefineProperty(this, "stripePaymentElementElements", _descriptor11, this);
      _initializerDefineProperty(this, "isEmpty", _descriptor12, this);
      _initializerDefineProperty(this, "isComplete", _descriptor13, this);
      _initializerDefineProperty(this, "isChargingInvoice", _descriptor14, this);
      _defineProperty(this, "confirmRouteChange", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (transition) {
          if (this.isDirty) {
            transition.abort();
            yield this.settings.confirmClose(this.isDirty);
            this.resetForm();
            transition.retry();
          }
        }
      }), null, "confirmRouteChange", "drop"));
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.settings.confirmClose(this.isDirty);
          this.resetForm();
          this.router.transitionTo('account.subscription.billing');
        }
      }), null, "handleClose", "drop"));
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          let paymentMethod;
          (false && !(this.stripePaymentElementElements) && (0, _debug.assert)('elements exists', this.stripePaymentElementElements));
          try {
            this.alerts.clear();
            paymentMethod = yield this.stripe.confirmPaymentMethod(this.stripePaymentElementElements, 'settings');
          } catch (error) {
            //Note: may show error if 3ds fails
            this.alerts.warning(error?.message);
            return;
          }
          try {
            yield this.settings.submitForm.perform(this.payment.updatePaymentMethod(paymentMethod.id, {
              location: 'account settings',
              route: this.update_card_origin
            }), 'account.subscription.billing.edit');
            if (this.isPastDue) {
              this.isChargingInvoice = true;
              this.events.on('account:updated', this.handleAccountUpdate);
            } else {
              yield this.payment.retrieveCard.perform();
              this.resetForm();
              this.alerts.success(this.intl.t('alerts.account.subscription.billing.update_card.success'));
              this.router.transitionTo('account.subscription.billing');
            }
          } catch {
            this.alerts.warning(this.intl.t('alerts.account.subscription.billing.update_card.error'));
          }
        }
      }), null, "handleSubmit", "drop"));
    }
    ///note: set in setupController

    get currentAccount() {
      return this.auth.currentAccount;
    }
    get isEditDisabled() {
      return this.settings.submitForm.isRunning;
    }
    get isRunning() {
      return this.handleSubmit.isRunning || this.isChargingInvoice;
    }
    get isSubmitDisabled() {
      return !this.isComplete || this.isChargingInvoice;
    }
    get isDirty() {
      return !this.isEmpty;
    }
    get isPastDue() {
      return this.subscriptions.isPastDue;
    }
    async onPaymentElementChange(arg) {
      const {
        complete,
        empty,
        elements
      } = arg;
      this.isComplete = complete;
      this.isEmpty = empty;
      this.stripePaymentElementElements = elements;
    }
    resetForm() {
      this.isEmpty = true;
      this.isComplete = false;
      this.isChargingInvoice = false;
    }

    /**
     * Event listener for if payment was saved while the user was past due.
     *
     * We can stop listening if they have had a recent failed charge or if they no longer become past due.
     */
    async handleAccountUpdate() {
      if (this.isPastDue) {
        const threshold = 10;
        const timeDiff = Math.floor(Date.now() / 1000) - (this.currentAccount.lastFailedChargeAt ?? 0);
        if (timeDiff < threshold) {
          await this.payment.retrieve.perform(true);
          this.trackPaymentStatus();
          this.isChargingInvoice = false;
          this.alerts.warning(this.intl.t('alerts.account.subscription.billing.update_card.failed_charge'));
          this.events.off('account:updated', this.handleAccountUpdate);
        }
      } else {
        await Promise.allSettled([this.payment.retrieveCard.perform(), this.payment.retrieve.perform(true)]);
        this.trackPaymentStatus();
        this.resetForm();
        this.alerts.success(this.intl.t('alerts.account.subscription.billing.update_card.success'));
        this.events.off('account:updated', this.handleAccountUpdate);
        this.router.transitionTo('account.subscription.billing');
      }
    }
    trackPaymentStatus() {
      const status = this.isPastDue ? 'failed' : 'success';
      this.segment.track('past-due-attempted-update-payment', {
        payment_status: status
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "events", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "stripePaymentElementElements", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isEmpty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "isChargingInvoice", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onPaymentElementChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onPaymentElementChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAccountUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAccountUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackPaymentStatus", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackPaymentStatus"), _class.prototype)), _class);
});